import { useContext } from 'react'
import { useSelector } from 'react-redux'
import { FormattedMessage, defineMessages } from 'react-intl'
import { AmplitudeContext } from '@homebot/shared-util-quartermaster'

// Utils
import { NEW_HOME } from '../../../../../constants/gems'
import { NEW_HOME_WIN } from '../../../../../constants/wins'
import { OVERLAY_HELPERS } from '../../../../../constants/navigation'

// Selectors
import { selectBuyerNewHomeBudgetWithCap } from '../../../../../store/selectors/home/equity/newHome'
import { selectNewHomeVideoThumbnail } from '../../../../../store/selectors/videos'

// Contexts
import { useTheme } from '@homebot/shared-ui-swashbuckle'

// Components
import { Text, Format } from '../../../..'
import ImportantNowCard from '../../ImportantNowCard'

// Assets
import DefaultThemeSvg from './DefaultThemeSvg'
import LightThemeSvg from './LightThemeSvg'

const newHomeMessages = defineMessages({
  nav: {
    id: 'ImportantNow.newHome.nav',
    defaultMessage: '\u25b6 Watch video',
  },
})

const NewHome = () => {
  const budget = useSelector(selectBuyerNewHomeBudgetWithCap)
  const videoThumbnailUrl = useSelector(selectNewHomeVideoThumbnail)
  const { theme } = useTheme()
  const { ampli } = useContext(AmplitudeContext)

  const Svg = theme.isLightThemeType ? LightThemeSvg : DefaultThemeSvg

  return (
    <ImportantNowCard
      name='NewHome'
      event={() => ampli?.winClicked({ win_type: NEW_HOME_WIN })}
      navTo={OVERLAY_HELPERS.purchasing.buildPath(NEW_HOME)}
      svgImage={Svg}
      imageUrl={videoThumbnailUrl}
      navMessage={videoThumbnailUrl && newHomeMessages.nav}
    >
      <FormattedMessage
        id='ImportantNow.spotlight.dreamHome'
        defaultMessage='You might have up to {newHomeBudget} in purchasing power for a new home'
        values={{
          newHomeBudget: (
            <Text element='span' weight='semibold' variant='success'>
              <Format.Currency value={budget} abbreviate />
            </Text>
          ),
        }}
      />
    </ImportantNowCard>
  )
}

export default NewHome
